import MobileSystemSetting from './MobileSystemSetting';

export default MobileSystemSetting;
